import * as React from 'react';
import { connect } from 'react-redux'

import { getActiveChannelId } from '../reducers/gui'
import { isQuickBetsActive }from '../reducers/gui'
import { getTimings } from '../reducers/timings'
import { getPhaseIdByChannelId } from '../reducers/timings';

import MatchListPresentation from '../presentations/MatchList/MatchListPresentation'

const mapStateToProps = (state:any) => {
    return ({
        timings: getTimings(state),
        activeChannelId: getActiveChannelId(state),
        quickBetsState: isQuickBetsActive(state),
        phase: getPhaseIdByChannelId(state, getActiveChannelId(state))
    })
};

export default connect( mapStateToProps )( MatchListPresentation )

